// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDJDjrTj_jcqzUBjSg-GhSM7wuNgB21FxY",
    authDomain: "mediate-b1628.firebaseapp.com",
    databaseURL: "https://mediate-b1628.firebaseio.com",
    projectId: "mediate-b1628",
    storageBucket: "mediate-b1628.appspot.com",
    messagingSenderId: "541576693631"
  }
};



// WEBPACK FOOTER //
// /var/www/html/mediate/src/environments/environment.ts